import { useListContext } from "ra-core";
import { FilterX } from "lucide-react";

import { Button } from "@/components/ui/button";

// LDF: Alle Filter (inkl. Suche) auf die Standardansicht zurücksetzen – zeigt, wie viele Filter aktiv sind.

// true, wenn Filter gesetzt sind, die von der Standardansicht abweichen
export const hasNonDefaultFilters = (filterValues: Record<string, unknown> | undefined, defaults: Record<string, unknown>) =>
  Object.entries(filterValues ?? {}).some(
    ([key, value]) => value !== undefined && value !== "" && JSON.stringify(defaults[key]) !== JSON.stringify(value),
  );

export const ResetFiltersButton = ({ defaults = {} }: { defaults?: Record<string, unknown> }) => {
  const { filterValues, setFilters } = useListContext();
  const active = Object.entries(filterValues ?? {}).filter(
    ([key, value]) => value !== undefined && value !== "" && JSON.stringify(defaults[key]) !== JSON.stringify(value),
  );
  if (!active.length) return null;
  return (
    <Button
      variant="outline"
      size="sm"
      className="w-full justify-center gap-1 border-primary/40 text-primary"
      onClick={() => setFilters(defaults, {})}
      title="Alle Filter und die Suche zurücksetzen"
    >
      <FilterX className="h-4 w-4" />
      Filter zurücksetzen ({active.length})
    </Button>
  );
};
